import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const {FiArrowRight,FiCheckCircle,FiShield,FiZap}=FiIcons;

const BOOKING_URL="https://app.urable.com/virtual-shop/cFNwotdAvEx76Evup5X1";

const trustBadges=[ 
  {icon: FiZap,text: "Fast Response"},
  {icon: FiShield,text: "Fully Insured"},
  {icon: FiCheckCircle,text: "No Obligation"},
];

export default function QuoteSection() {
  return ( 
    <section className="py-24 bg-slate-950 relative overflow-hidden border-t border-slate-800"> 
      {/* Background Effects */} 
      <div className="absolute inset-0 pointer-events-none"> 
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent" /> 
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl" /> 
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl" /> 
      </div> 

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center"> 
        <motion.span initial={{opacity: 0,y: 10}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} className="inline-block text-blue-500 font-bold tracking-widest uppercase text-xs mb-3" > 
          Ready to Book? 
        </motion.span> 
        <motion.h2 initial={{opacity: 0,y: 10}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: 0.05}} className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-6" > 
          Schedule Your Detail 
        </motion.h2> 
        <motion.p initial={{opacity: 0,y: 10}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: 0.1}} className="text-slate-400 text-lg max-w-2xl mx-auto mb-10" > 
          Head over to our secure booking portal to select your packages, share your vehicle details, and pick a time that works best for you. 
        </motion.p> 

        <motion.div initial={{opacity: 0,y: 10}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: 0.15}} className="flex justify-center mb-10" > 
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-blue-600 text-white font-black rounded-sm hover:bg-blue-500 transition-all uppercase tracking-wide text-lg shadow-[0_0_40px_rgba(37,99,235,0.4)] hover:shadow-[0_0_60px_rgba(37,99,235,0.6)] transform hover:-translate-y-1" > 
            Book on Urable <FiArrowRight className="text-xl" /> 
          </a> 
        </motion.div> 

        <motion.div initial={{opacity: 0,y: 10}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: 0.2}} className="flex flex-wrap justify-center gap-6" > 
          {trustBadges.map((badge,i)=> ( 
            <div key={i} className="flex items-center gap-2 text-slate-500 text-sm"> 
              <badge.icon className="text-blue-500/70 text-lg flex-shrink-0" /> 
              <span className="font-semibold uppercase tracking-wider text-xs">{badge.text}</span> 
            </div> 
          ))} 
        </motion.div> 
      </div> 
    </section> 
  );
}